import React from 'react'
import { Dialog, Slide, useTheme, useMediaQuery } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMain({ open, handleClose, fullWidth, children, maxWidth }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      fullScreen
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperProps={matches ? { style: { margin: "0px", width: "calc(100% - 10px)", maxHeight: "calc(100% - 10px)" } } : {}}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose(event, reason);
        }
      }}>
      {children}
    </Dialog>
  );
}

export default DialogMain;